import { catchError } from "../../../Actions/Error.action";

export const PRODUCT_LIST_PAGE_RECEIVE = "PRODUCT_LIST_PAGE_RECEIVE";
export const PRODUCT_LIST_PAGE_ERROR = 'PRODUCT_LIST_PAGE_ERROR';
export const PRODUCT_LIST_CATEGORIES = 'PRODUCT_LIST_CATEGORIES';
export const PRODUCT_LIST_ALL_CATEGORIES = "PRODUCT_LIST_ALL_CATEGORIES";

export const fetchProductListPageData = (id) => async (dispatch) => {
    const html = document.querySelector("html");
    if (html) {
        const culture = html.getAttribute("lang");
        if (culture && culture !== "") {
            try {
                const response = await fetch(`/api/product/${id}/${culture}`)
                    .then(response => {
                        return response.json();
                    })
                    .then(result => {
                        dispatch(receive(result));
                    })
                    .catch(ex => {
                        dispatch(catchError(ex, error => setError(error)));
                    });
            } catch (error) {
                dispatch(catchError(error, setError));
            }
        }
    }
};

export const receive = result => ({
    type: PRODUCT_LIST_PAGE_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: PRODUCT_LIST_PAGE_ERROR,
    payload: {
        error,
    },
})

export const setCategories = (categories) => ({
    type: PRODUCT_LIST_CATEGORIES,
    payload: categories
});

export const setAllCategories = (categories) => ({
    type: PRODUCT_LIST_ALL_CATEGORIES,
    payload: categories
});